import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export const selectAuthorizedProductIds = createSelector(
  (state: RootState) => state.userRdc.userCatalog,
  (catalogs) => {
    if (!catalogs || catalogs.length === 0) return null;
    const authorizedProductIds = new Set<number>();
    catalogs.forEach((catalog: { products: any[] }) => {
      if (catalog.products) {
        catalog.products.forEach((product) => {
          if (product.id) authorizedProductIds.add(product.id);
        });
      }
    });
    return Array.from(authorizedProductIds);
  }
);

export const selectHidePrices = createSelector(
  (state: RootState) => state.userRdc.userCatalog,
  (catalogs) => {
    if (!catalogs || catalogs.length === 0) return false;
    return catalogs.some((catalog: { hidePrices: boolean }) => catalog.hidePrices);
  }
);

export const shouldHidePriceForProduct = (productId: number, catalogs: any[]): boolean => {
  if (!catalogs || catalogs.length === 0) return false;

  const catalogsArray = Array.isArray(catalogs) ? catalogs : [catalogs];
  const catalogsWithProduct = catalogsArray.filter((catalog: any) =>
    catalog.products?.some((p: any) => p.id === productId)
  );

  if (catalogsWithProduct.length === 0) return false;

  return catalogsWithProduct.every((c: any) => c.hidePrices === true);
};

export function isProductInUserCatalog(productId: number, userCatalog: any[]): boolean {
  if (!userCatalog || userCatalog.length === 0) return true;

  const hasRestrictedCatalog = Array.isArray(userCatalog)
    ? userCatalog.some(catalog => catalog.hidePrices === true)
    : false;
  if (!hasRestrictedCatalog) return true;

  return userCatalog.some((catalog) =>
    catalog.hidePrices === true &&
    catalog.products?.some((product: any) => product.id === productId)
  );
}

export function getProductIdFromItem(productItem: any, isItemForRequestOffer: boolean): number {
  return !isItemForRequestOffer ? productItem.product.id : productItem.variant.product.id;
}

export function shouldHideProduct(productItem: any, isItemForRequestOffer: boolean, catalogs: any[]): boolean {
  const productId = getProductIdFromItem(productItem, isItemForRequestOffer);
  return !isProductInUserCatalog(productId, catalogs);
}

export function canUserSeeProduct(productId: number, catalogs: any[]): boolean {
  // Aucun catalogue alors on peut voir tous les prix
  if (!catalogs || catalogs.length === 0) return true;

  let hasMatchingProduct = false;

  for (const catalog of catalogs) {
    const productIsInCatalog = catalog.products?.some((product: any) => product.id === productId);

    if (productIsInCatalog) {
      hasMatchingProduct = true;

      // Si un des catalogues contient le produit et ne cache pas les prix, alors OK
      if (!catalog.hidePrices) return true;
    }
  }

  // Si tous les catalogues qui contiennent le produit le masquent → interdit
  return !hasMatchingProduct ? false : false;
}
